import { UpdatedRecordsType } from '@/types/logs'

export const UPDATED_RECORDS_LABEL_MAP = {
    [UpdatedRecordsType.New]: 'New record',
    [UpdatedRecordsType.Flagged]: 'Record flagged',
    [UpdatedRecordsType.Unfinished]: 'Record unfinished',
    [UpdatedRecordsType.MissingInfo]: 'Missing info',
    [UpdatedRecordsType.MissingOfficialReport]: 'Missing report',
    [UpdatedRecordsType.ReportUpdated]: 'Report updated',
    [UpdatedRecordsType.ReportSent]: 'Report sent',
    [UpdatedRecordsType.ViewInfo]: 'View info',
}
